import React from "react";
import { FaCamera } from "react-icons/fa";
import CollapsibleGallery from "./CollapsibleGallery";
import { useSelector } from "react-redux";
import EmptyContent from "../../EmptyContent";

const ImagesTab = ({ onSegmentOpen }) => {
  const { segments } = useSelector((state) => state?.hotbar);

  // Calculate the total number of valid images
  const totalImages = segments?.reduce((sum, segment) => {
    return (
      sum +
      (segment?.items?.images?.filter((image) => image?.src !== null).length ||
        0)
    );
  }, 0);

  return (
    <>
      {totalImages > 0 ? (
        segments?.map((segment) =>
          segment?.items?.images?.length ? (
            <CollapsibleGallery
              key={segment.segmentId} // Assuming segmentId is unique
              images={segment.items.images.filter(
                (image) => image?.src !== null
              )}
              icon={<FaCamera />}
              title={segment.title}
              onSegmentOpen={onSegmentOpen}
              segmentId={segment.segmentId}
              segmentColor={segment.segmentColor}
            />
          ) : null
        )
      ) : (
        <EmptyContent />
      )}
    </>
  );
};

export default ImagesTab;
